module.exports = __webpack_public_path__ + "img/logo.35dd8df6.png";